import React from 'react';
import PropTypes from 'prop-types';

import { uiConfig } from '../../../../../../../../../conf/concepts';

// Components
import Table from '../../../../../../../../../../components/Table';
import { Spinner } from '../../../../../../../../../../components/Spinner';
import { ConstraintTypeModal } from './ConstraintTypeModal';

// Context
import { CriteriaStoreContext } from '../../../../../../../../state/criteria/context';

// Hooks
import { useGetCodes } from '../../../../../../../../../../common/hooks/useGetCodes';

// Utils
import { translateUIConfigForTable } from '../../../../../../../../../../common/utility';

export const CodesTableModal = (props) => {
    const { sessionToken } = React.useContext(CriteriaStoreContext);
    const { data, isLoading } = useGetCodes({ sessionToken });
    const { columns, initialState } = translateUIConfigForTable(uiConfig);

    return (
        <ConstraintTypeModal header={'Codes'} id={'constraint-type-code-modal'} {...props}>
            {!isLoading ? (
                <Table
                    withHeader={true}
                    columns={columns}
                    data={data}
                    withActions={false}
                    rowClickAction={(rowData) => props?.onSelect?.(rowData)}
                    id={'codes-manager'}
                    label={'Codes'}
                    showControlDeck={true}
                    paginated={true}
                    loading={isLoading}
                    initialState={initialState}
                />
            ) : (
                <Spinner size={'2.3rem'} color={'#7f7f7f'} style={{ margin: '0 auto' }} />
            )}
        </ConstraintTypeModal>
    );
};

CodesTableModal.propTypes = {
    closeDialog: PropTypes.func.isRequired,
    onSelect: PropTypes.func
};

export default CodesTableModal;
